module.exports = __webpack_public_path__ + "static/media/flower_seller1.9a5bce89.wav";